import { Popover } from 'antd'
import { FC, ReactNode, useState } from 'react'
import cn from './index.module.css'
import { CloseOutlined } from '@ant-design/icons'
import MarkdownViewer from '../MarkdownViewer/MarkdownViewer'
import { useCurrentHelper } from './useCurrentHelper'
import HideSupportModal from './HideSupportModal/HideSupportModal'

interface ISupportHelper {
  children: ReactNode
  isDisabled?: boolean
}

const SupportHelper: FC<ISupportHelper> = ({ children, isDisabled }) => {
  const { message, onChangeVisibility } = useCurrentHelper()
  const [showHideModal, setShowHideModal] = useState(false)

  const onHideModal = (state: boolean) => {
    onChangeVisibility(false, state)
    setShowHideModal(false)
  }

  return (
    <>
      {isDisabled ? (children) : (
        <>
          <Popover
            placement="right"
            content={
              message && (
                <SupportCard
                  onHide={() => setShowHideModal(true)}
                  message={message ?? ''}
                />
              )
            }
            showArrow={false}
            overlayClassName={cn.popover}
            open={!!message}
            getPopupContainer={(trigger) => trigger}
          >
            <div
              onClick={() => {
                onChangeVisibility(true, true)
              }}
            >
              {children}
            </div>
          </Popover>
          <HideSupportModal
            isVisible={showHideModal}
            onDismiss={() => setShowHideModal(false)}
            onAction={onHideModal}
          />{' '}
        </>
      )}
    </>
  )
}

const SupportCard = ({
  message,
  onHide,
}: {
  message: string
  onHide: () => void
}) => {
  return (
    <div className={cn.cardContent}>
      <div className={cn.imageWrapper}>
        <img src="/support_icon.png" alt="support" className={cn.image} />
        <div className={cn.supportOnlineDot}></div>
      </div>
      <div className={cn.cardBody}>
        <MarkdownViewer
          className={cn.messageWrapper}
          classNameLink={cn.linkStyle}
          text={message}
        />
        <MarkdownViewer
          className={cn.questionsLink}
          classNameLink={cn.linkStyle}
          text="Есть вопросы - напиши в [тех.поддержку](https://t.me/que_impulse)"
        />
      </div>
      <div className={cn.rightSide}>
        <CloseOutlined
          onClick={onHide}
          className={cn.closeIcon}
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        />
      </div>
    </div>
  )
}

export default SupportHelper
function useMatchedRoute(routes: any) {
  throw new Error('Function not implemented.')
}
